<div class="close-wrapper">
	<button mat-mini-fab type="button" (click)="dialogRef.close()"><mat-icon>close</mat-icon></button>
</div>
<mat-dialog-content>
</mat-dialog-content>
<mat-dialog-actions class="phone-buttons">
	<button mat-raised-button color="primary" class="col2" type="button" ><a [href]="phone_link">{{ community.phone }}</a></button>
	<p>Let them know Senior Communities Guide sent you!</p>
</mat-dialog-actions>